import angular from 'angular';
import _ from 'lodash';

(function() {
  'use strict';
  angular.module('app.core').factory('InvoiceStatus', InvoiceStatusData);

  InvoiceStatusData.$inject = ['$translate', 'logger', 'UtilSvc'];

  /* @ngInject */
  function InvoiceStatusData($translate, logger, UtilSvc) {
    InvoiceStatus.prototype = {
      build: build,
      getStatusLabel: getStatusLabel,
      getStatusComment: getStatusComment
    };

    function InvoiceStatus(invoiceStatusData) {
      if (invoiceStatusData) {
        this.build(invoiceStatusData);
      }
    }

    return InvoiceStatus;

    /////////////////////

    function build(invoiceStatusData) {
      if (invoiceStatusData) {
        this.author = invoiceStatusData.author || null;
        this.status = invoiceStatusData.status || null;
        this.statusDate = UtilSvc.parseDate(invoiceStatusData.statusDate);
        this.statusComment = invoiceStatusData.statusComment || null;
        this.statusErrorMessages = invoiceStatusData.statusErrorMessages || null;
      } else {
        logger.error('Error with invoiceStatus', invoiceStatusData);
      }
    }

    /**
     * Récupère le label traduit du statut
     */
    function getStatusLabel() {
      if (this.status) {
        return $translate.instant('invoices.status.' + angular.lowercase(this.status));
      }
      return '';
    }

    function getStatusComment() {
      var label = [];
      if (this.statusComment) {
        label.push(this.statusComment);
      }

      if (this.statusErrorMessages) {
        label = label.concat(this.statusErrorMessages);
      }

      // Supprime les doublons (il se peut que le commentaire soit identique au message d'erreur)
      return _.uniq(label);
    }
  }
})();
